export const URL_PATHS = {
	TOP_UP_ADD_ONS_ROOT: 'dashboard/payments/top-up-add-ons',
	CHOOSE_SERVICES: 'choose',
	TOP_UP: 'top-up',
	ADD_ONS: 'add-ons',
};
export const ITEM_TYPE = {
	TOP_UP: 'TOP_UP',
	SERVICES: 'SERVICES',
};
